import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth, GoogleAuthProvider } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import {
  AUTH_EMULATOR_PORT,
  EMULATOR_HOST,
  firebaseConfig,
  FIRESTORE_EMULATOR_PORT,
  FUNCTIONS_EMULATOR_PORT,
  FUNCTIONS_REGION,
  useEmulators,
} from './config';

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const firestore = getFirestore(app);

/**
 * ต้องระบุ region ให้ตรงกับที่ deploy จริง — ค่า default ของ SDK คือ `us-central1`
 * ถ้าไม่ระบุ จะเรียก function ที่ไม่มีอยู่แล้วได้ 404 โดยไม่บอกว่าเพราะอะไร
 */
export const functions = getFunctions(app, FUNCTIONS_REGION);

export const googleProvider = new GoogleAuthProvider();

if (useEmulators) {
  // disableWarnings ปิดแบนเนอร์สีเหลืองของ Firebase ที่บังหน้าจอตอน dev
  connectAuthEmulator(auth, `http://${EMULATOR_HOST}:${AUTH_EMULATOR_PORT}`, {
    disableWarnings: true,
  });
  connectFirestoreEmulator(firestore, EMULATOR_HOST, FIRESTORE_EMULATOR_PORT);
  connectFunctionsEmulator(functions, EMULATOR_HOST, FUNCTIONS_EMULATOR_PORT);
}
